/* eslint-disable */
export function getPublicPath(hostname) {
    return hostname.includes('local') || /^[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}$/.test(hostname)
        ? `${FINN.travel.cdnBaseUrl}${FINN.travel.contextPath}/assets/scripts/`
        : 'https://static.finncdn.no/_c/travel-flight-web/reise/flybilletter/assets/scripts/';
}

window.__requireFrom__ = () => getPublicPath(window.location.hostname);
